module.exports = __webpack_public_path__ + "components/signup/static/cards-c79739d41c54e546336791c9d60cd891.png";